import { render } from "./CalendarMonth.vue?vue&type=template&id=80b0169a&scoped=true&ts=true"
import script from "./CalendarMonth.vue?vue&type=script&lang=ts"
export * from "./CalendarMonth.vue?vue&type=script&lang=ts"

import "./CalendarMonth.vue?vue&type=style&index=0&id=80b0169a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b0169a"]])

export default __exports__